import { Component, ViewChild } from '@angular/core';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { BaseEntity, BaseState, WebAPIRequestListParams } from '@m4u-angular/base/entities/BaseEntities';
import { WebAPICredentialEndpoint } from '@m4u-angular/core/endpoints/webapi-credential.endpoint';
import { WebAPIRequestEndpoint } from '@m4u-angular/core/endpoints/webapi-request.endpoint';
import { RequestHistoryGridComponent } from '../request-history-grid/request-history-grid.component';

class State extends BaseState {
    CurrentCredentialID: number;

    Module: string;
    Controller: string;
    Action: string;
    DateFrom: Date;
    DateTo: Date;

    Controllers: string[];
    Actions: string[];
    Modules: string[];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-request-history-list',
    templateUrl: './request-history-list.component.html',
    styleUrls: ['./request-history-list.component.scss']
})
export class RequestHistoryListComponent extends BasePageComponent<BaseEntity, State> {

    @ViewChild(RequestHistoryGridComponent) grid: RequestHistoryGridComponent;

    constructor(A: ServiceBagService,
        private webAPICredentialEndpoint: WebAPICredentialEndpoint,
        private webAPIRequestEndpoint: WebAPIRequestEndpoint) {
        super(A, 'RequestHistoryListComponent', BaseEntity, State);
    }

    protected override OnInitComponent() {
        this.LoadCredentials();
        this.InitControllers();
        this.InitActions();
        this.InitModules();

        this.ReadQuery();
    }

    protected override OnGetToolbarSettings() {
        const settings = new ToolbarSettings;
        settings.IsAllowFilter = true;
        settings.IsAllowExport = true;
        settings.GridExtender = this.grid?.G;

        return settings;
    }

    protected override OnApplyFilter() {
        this.LoadDataSource();
    }

    protected override OnClearFilter(): void {
        this.State.Module = undefined;
        this.State.Controller = undefined;
        this.State.Action = undefined;
        this.State.DateFrom = undefined;
        this.State.DateTo = undefined;
        this.LoadDataSource();
    }

    public OnCredentialChanged() {
        this.LoadDataSource();
    }

    public OnDateFromChange(dateFrom) {
        if (!dateFrom?.value) return;

        this.State.DateFrom = new Date(dateFrom.value.setHours(0, 0, 0));
    }

    public OnDateToChange(dateTo) {
        if (!dateTo?.value) return;

        this.State.DateTo = new Date(dateTo.value.setHours(23, 59, 59, 999));
    }

    private LoadCredentials() {
        this.DataSources['Credentials'] = new DataSourceCustomAction((options) => this.webAPICredentialEndpoint.GetList(options), (entryID) => this.webAPICredentialEndpoint.Get(entryID));
    }

    private LoadDataSource() {
        if (!this.State.CurrentCredentialID) {
            this.DataSources['Requests'] = undefined;
            return;
        }

        const params = new WebAPIRequestListParams();
        params.CredentialID = this.State.CurrentCredentialID;
        params.ModuleName = this.State.Module;
        params.Controller = this.State.Controller;
        params.Action = this.State.Action;
        params.DateFrom = this.State.DateFrom;
        params.DateTo = this.State.DateTo;

        this.DataSources['Requests'] = new DataSourceCustomAction((options) => this.webAPIRequestEndpoint.ListEx(params, options), undefined, undefined, false);
    }

    private InitControllers() {
        this.Do(this.webAPIRequestEndpoint.GetPossibleControllers(), false, (response) => {
            this.State.Controllers = response.Data;
        });
    }

    private InitActions() {
        this.Do(this.webAPIRequestEndpoint.GetPossibleActions(), false, (response) => {
            this.State.Actions = response.Data;
        });
    }

    private InitModules() {
        this.Do(this.webAPIRequestEndpoint.GetPossibleModules(), false, (response) => {
            this.State.Modules = response.Data;
        });
    }

    private ReadQuery() {
        if (this.QueryParams.CredentialID) {
            this.State.CurrentCredentialID = +this.QueryParams.CredentialID;
            this.OnCredentialChanged();
        }
    }
}
